/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { DeepInfraBalanceResponse } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { GetAdminNotificationsResponse } from '../models';
// @ts-ignore
import type { MarkAdminNotificationsReadBody } from '../models';
// @ts-ignore
import type { MarkAdminNotificationsReadResponse } from '../models';
/**
 * AdminNotificationApiApi - axios parameter creator
 */
export const AdminNotificationApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [type] 
         * @param {boolean} [unreadOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationApiGetAdminNotifications: async (page?: number, pageSize?: number, type?: string | null, unreadOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (unreadOnly !== undefined) {
                localVarQueryParameter['unread_only'] = unreadOnly;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationApiGetDeepinfraBalance: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/deepinfra/balance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MarkAdminNotificationsReadBody} markAdminNotificationsReadBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationApiMarkAdminNotificationsRead: async (markAdminNotificationsReadBody: MarkAdminNotificationsReadBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'markAdminNotificationsReadBody' is not null or undefined
            assertParamExists('adminNotificationApiMarkAdminNotificationsRead', 'markAdminNotificationsReadBody', markAdminNotificationsReadBody)
            const localVarPath = `/admin/notifications/read`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markAdminNotificationsReadBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminNotificationApiApi - functional programming interface
 */
export const AdminNotificationApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminNotificationApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [type] 
         * @param {boolean} [unreadOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotificationApiGetAdminNotifications(page?: number, pageSize?: number, type?: string | null, unreadOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdminNotificationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotificationApiGetAdminNotifications(page, pageSize, type, unreadOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminNotificationApiApi.adminNotificationApiGetAdminNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotificationApiGetDeepinfraBalance(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeepInfraBalanceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotificationApiGetDeepinfraBalance(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminNotificationApiApi.adminNotificationApiGetDeepinfraBalance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {MarkAdminNotificationsReadBody} markAdminNotificationsReadBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotificationApiMarkAdminNotificationsRead(markAdminNotificationsReadBody: MarkAdminNotificationsReadBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarkAdminNotificationsReadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotificationApiMarkAdminNotificationsRead(markAdminNotificationsReadBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminNotificationApiApi.adminNotificationApiMarkAdminNotificationsRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminNotificationApiApi - factory interface
 */
export const AdminNotificationApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminNotificationApiApiFp(configuration)
    return {
        /**
         * 
         * @param {AdminNotificationApiApiAdminNotificationApiGetAdminNotificationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationApiGetAdminNotifications(requestParameters: AdminNotificationApiApiAdminNotificationApiGetAdminNotificationsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAdminNotificationsResponse> {
            return localVarFp.adminNotificationApiGetAdminNotifications(requestParameters.page, requestParameters.pageSize, requestParameters.type, requestParameters.unreadOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationApiGetDeepinfraBalance(options?: RawAxiosRequestConfig): AxiosPromise<DeepInfraBalanceResponse> {
            return localVarFp.adminNotificationApiGetDeepinfraBalance(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminNotificationApiApiAdminNotificationApiMarkAdminNotificationsReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationApiMarkAdminNotificationsRead(requestParameters: AdminNotificationApiApiAdminNotificationApiMarkAdminNotificationsReadRequest, options?: RawAxiosRequestConfig): AxiosPromise<MarkAdminNotificationsReadResponse> {
            return localVarFp.adminNotificationApiMarkAdminNotificationsRead(requestParameters.markAdminNotificationsReadBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminNotificationApiGetAdminNotifications operation in AdminNotificationApiApi.
 */
export interface AdminNotificationApiApiAdminNotificationApiGetAdminNotificationsRequest {
    readonly page?: number

    readonly pageSize?: number

    readonly type?: string | null

    readonly unreadOnly?: boolean
}

/**
 * Request parameters for adminNotificationApiMarkAdminNotificationsRead operation in AdminNotificationApiApi.
 */
export interface AdminNotificationApiApiAdminNotificationApiMarkAdminNotificationsReadRequest {
    readonly markAdminNotificationsReadBody: MarkAdminNotificationsReadBody
}

/**
 * AdminNotificationApiApi - object-oriented interface
 */
export class AdminNotificationApiApi extends BaseAPI {
    /**
     * 
     * @param {AdminNotificationApiApiAdminNotificationApiGetAdminNotificationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminNotificationApiGetAdminNotifications(requestParameters: AdminNotificationApiApiAdminNotificationApiGetAdminNotificationsRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminNotificationApiApiFp(this.configuration).adminNotificationApiGetAdminNotifications(requestParameters.page, requestParameters.pageSize, requestParameters.type, requestParameters.unreadOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminNotificationApiGetDeepinfraBalance(options?: RawAxiosRequestConfig) {
        return AdminNotificationApiApiFp(this.configuration).adminNotificationApiGetDeepinfraBalance(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminNotificationApiApiAdminNotificationApiMarkAdminNotificationsReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminNotificationApiMarkAdminNotificationsRead(requestParameters: AdminNotificationApiApiAdminNotificationApiMarkAdminNotificationsReadRequest, options?: RawAxiosRequestConfig) {
        return AdminNotificationApiApiFp(this.configuration).adminNotificationApiMarkAdminNotificationsRead(requestParameters.markAdminNotificationsReadBody, options).then((request) => request(this.axios, this.basePath));
    }
}

